import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'prodgenerator';

const prodgeneratorService = {
  getOrders: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orders`,
      data,
    });
  },

  getsourcelistByItemCode: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/sourcelistByItemCode`,
      data,
    });
  },

  createProduction: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/createProduction`,
      data,
    });
  },

  getAllSourceDataByItemCodes: (itemCodes) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/allSourceDataByItemCodes`,
      data: { itemCodes },
    });
  },

  updateOrderLine: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default prodgeneratorService;
